import { Typography } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';

const PaywallCardSigninHeader: FC = () => {
    const { t } = useTranslation('freemium');

    return <Typography variant="body2">{t('paywall.header.text')}</Typography>;
};

export default PaywallCardSigninHeader;
